<template>
    <div class="custom-search" ref="dropdownRef">
        <div class="input-group input-group input-group-merge ms-1 w-100">
            <span class="input-group-text">
                <img src="@/assets/search-icon.svg" alt="Search" width="14" height="14" />
            </span>
          <input type="text" class="form-control"
            id="chat-search" v-model="searchTxt" @input="onSearch" @focus="onSearch"
            :placeholder="`Search ${title.toLowerCase()}`" aria-label="Search..."
            aria-describedby="chat-search"/>
        </div>

        <ul class="dropdown-search deep-shadow">
            <li
                @click="onHandleSelect(item, index)"
                v-for="(item, index) in searchResults" 
                :key="item.id" class="search-list-item">

                <div class="form-check">
                    <input v-model="item.isSelected" class="form-check-input" type="checkbox">
                    <label :class="item.isSelected && 'text-primary text-bold'" class="form-check-label">
                        {{ item.name }}
                    </label>
                </div>
            </li>
        </ul>
        
    </div>
</template>

<script setup>
import useDetectOutsideClick from '@/services/useDetectOutsideClick';
import { reactive, ref } from 'vue';
const props = defineProps(['title', 'onHandleSearch', 'searchResults', 'clearSearchResult', 'onSelectNote']);
const emit = defineEmits(['onHandleSearch', 'clearSearchResult', 'onSelectNote'])
const dropdownRef = ref(null)
const searchTxt = ref('');

useDetectOutsideClick(dropdownRef, () => {
    emit('clearSearchResult')
})

function onHandleSelect(item, index) {
    emit('onSelectNote', item);
}

const onSearch = () => {
    emit('onHandleSearch', searchTxt.value)
}
</script>

<style scoped>
.custom-search{
    position: relative;
    width: 50%;
}
.search-list-item:last-child {
    border: none;
}
.search-list-item {
    display: flex;
    align-items: center;
    padding: 5px;
    margin: 5px;
    border-bottom: 1px solid #f1f1f1;
    cursor: pointer;
}
.search-list-item:hover {
    background: #f9f7f7;
}
.dropdown-search {
    position: absolute;
    width: 100%;
    max-height: 300px;
    overflow-y: scroll;
    left: 4%;
    padding-left: 0;
    background: #ffff;
    z-index: 99999;
}

</style>